import React, { type ReactNode } from 'react';

import {
  type ColumnInfoType,
  type ColumnInfoValueType,
} from 'types/ColumnInfo';
import TextField from 'ui/TextField';
import ImageField from 'ui/ImageField';
import ListTextField from 'ui/ListTextField';

export const addDataToInfoMap = (
  data: Record<string, any>,
  infoMap: ColumnInfoType
): Record<string, any> => {
  const combinedMap: Record<string, any> = {};
  for (const key in infoMap) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      let value = data[key];
      if (
        infoMap[key]?.function !== null &&
        infoMap[key]?.function !== undefined
      ) {
        value = infoMap[key].function?.(data[key]);
      }
      combinedMap[key] = {
        ...infoMap[key],
        data: value,
      };
    }
  }
  return combinedMap;
};

export const branchComponent = (
  key: string,
  value: ColumnInfoValueType
): ReactNode => {
  if (value.type === 'text') {
    return <TextField data={value.data as string | number} />;
  } else if (value.type === 'image') {
    if (value.data?.image) {
      return <ImageField data={value.data as { image: string }} />;
    }
    return <ImageField data={{ image: value.data } as { image: string }} />;
  } else if (value.type === 'listText') {
    return <ListTextField data={value.data as string[] | number[]} />;
  } else if (value.type === 'hidden') {
    return <></>;
  } else {
    return <></>;
  }
};
